<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Print Quotation",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
    // Loader,
  },
  data() {
    return {
      title: "Print Quotation",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Quotations",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",    
      id: atob(this.$route.params.id),
      isGeneratingPdf: false,
      whatsappTargetPhone: '',
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("quotations", ["Quotation","SaveStatus"]),
    ...mapGetters("setting", ["PaymentOptionsData"]),


    /**
     * Total no. of records
     */

    rows() {
      return this.Quotation ? this.Quotation.length : 1;
    },

    logoSource() {
      if (this.Quotation && this.Quotation.business2.Businesslogo_base64) {
          return this.Quotation.business2.Businesslogo_base64;
      }
      if (this.Quotation && this.Quotation.business2.Businesslogo) {
          return this.Quotation.business2.Businesslogo;
      }
      return null;
    }
    

    /**
     * Todo list of records
     */
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.Quotation ? this.Quotation.length : 1;
  },

  methods: {
    ...mapActions({
      FetchQuotation: "quotations/fetchQuotation",
      notifySuccess: "notification/success",
      notifyError: "notification/error",
      FetchModes: "setting/fetchPaymentOptionsData",        
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    UpdateSetting(id, status) {
      let activeoption = this.PaymentOptionsData.find(item => item.id == id);
      if (activeoption) {
        activeoption.showstatus = status === 1 ? 0 : 1;
      }
    },

    formatPhoneNumber(phone) {
      if (!phone) return null;
      let dialcode = this.Quotation.business2.country.dial_code;
      return dialcode + phone.toString().replace(/\D/g, '').slice(-9);
    },

    async generateAndSharePdf(shareType) {
      this.isGeneratingPdf = true;
      const quotationElement = document.getElementById('quotation-content');
      
      if (!quotationElement) {
        this.notifyError({ msg: "Error: Could not find quotation content." });
        this.isGeneratingPdf = false;
        return;
      }

      try { 
        quotationElement.classList.add('pdf-generating');       
        const canvas = await html2canvas(quotationElement, {
          scale: 2,
          useCORS: true,
           ignoreElements: (el) => {
            // 1.hide for print
            if (el.classList.contains('d-print-none')) return true;

            // 2. ignore unchecked payment-method rows
            if (el.classList.contains('payment-option-hidden-on-print')) return true;
            return false;
          }
        });
        
        const imgData = canvas.toDataURL('image/jpeg', 1.0);
        const pdf = new jsPDF('p','mm','a4' );
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Height of the canvas in PDF scale
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        
        // Add first page
        pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;

        // Add more pages if needed
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, position, pdfWidth, imgHeight);
          heightLeft -= pdfHeight;
        }
        const quotationFileName = `Quotation-${this.Quotation.quotation_number}-${this.Quotation.customer}-${moment(new Date()).format("YYYY-MM-DD")}.pdf`;

        if(shareType === 'app'){
          const pdfBlob = pdf.output('blob');
          const file = new File([pdfBlob], quotationFileName, { type: 'application/pdf' });   
          if (navigator.share && navigator.canShare({ files: [file] })) {
            await navigator.share({
              title: `Invoice ${this.Quotation.quotation_number}`,
              text: `Hello ${this.Quotation.customerobj.name},\n\nPlease find your quotation attached.\n\nThank you!`,
              files: [file],
            });
            this.notifySuccess({ msg: "Shared successfully!" });
          } 
        }else if (shareType === 'email') {
          pdf.save(quotationFileName);
          const successMessage = "The quotation has been downloaded as "+quotationFileName+". Please attach this file to your message.";
          this.notifySuccess({ msg: successMessage });
          const customerEmail = this.Quotation.customerobj.email;
          const subject = `Invoice ${this.Quotation.quotation_number} from ${this.Quotation.business2.name}`;
          const body = `Hello ${this.Quotation.customerobj.name},\n\nPlease find our quotation attached.\n\nThank you!`;
          window.open(`mailto:${customerEmail || ''}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
        } else if (shareType === 'whatsapp') {
          pdf.save(quotationFileName);
          const successMessage = "The quotation has been downloaded as "+quotationFileName+". Please attach this file to your message.";
          this.notifySuccess({ msg: successMessage });
          const customerPhone = this.Quotation.customerobj.contact; 
          this.whatsappTargetPhone = this.formatPhoneNumber(customerPhone);
          if (this.whatsappTargetPhone) {
              this.$bvModal.show('share-whatsapp-modal');
          } else {
              this.notifyError({ msg: "Cannot share via WhatsApp because the customer does not have a contact number saved." });
          }
        }
      } catch (error) {
        this.notifyError({ msg: "An error occurred while generating the PDF. Please ensure you are connected to the internet." });
      } finally {
        this.isGeneratingPdf = false;
      }
    },
    shareToWhatsApp(type) {
      const message = `Hello, please find attached Quotation ${this.Quotation.quotation_number}.`;
      const encodedMessage = encodeURIComponent(message);
      let url = '';
      if (this.whatsappTargetPhone) {
          url = type === 'app' 
              ? `whatsapp://send?phone=${this.whatsappTargetPhone}&text=${encodedMessage}` 
              : `https://web.whatsapp.com/send?phone=${this.whatsappTargetPhone}&text=${encodedMessage}`;
          if (type === 'app') {
              window.location.href = url;
          } else {
              window.open(url, '_blank');
          }
      }
      this.$bvModal.hide('share-whatsapp-modal');
    },

    Print(){
      setTimeout(() => {
        window.onafterprint = window.close;
        window.print();
      }, 1000);
    },
  },
  created() {
    this.FetchQuotation(this.id);
    this.FetchModes(); 
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />
    <div class="row px-2">
      <div class="col-lg-12">
        <!-- The ID is moved to the wrapper for better control -->
        <div class="card px-3" id="quotation-content-wrapper">
          <div class="card-body" id="quotation-content">
              <div class="row d-print-none mb-3">
                <div class="col-md-12" align="right">
                  <!-- Share Button -->
                  <div class="btn-group me-2">
                    <button type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-share-alt"></i> Share <i class="mdi mdi-chevron-down"></i>
                    </button>
                    <div class="dropdown-menu">
                       <a class="dropdown-item" href="#" @click="generateAndSharePdf('app')"><i class="fa fa-desktop me-2"></i> Any App</a>
                       <a class="dropdown-item" href="#" @click="generateAndSharePdf('email')"><i class="fa fa-envelope me-2"></i> Email</a>
                       <a class="dropdown-item" href="#" @click="generateAndSharePdf('whatsapp')"><i class="fab fa-whatsapp me-2"></i> WhatsApp</a>
                    </div>
                  </div>
                  <!-- Print and Back Buttons -->
                  <b-button variant="success" @click="Print()" class="me-2"><i class="fa fa-print"></i> Print</b-button>
                  <b-button variant="primary" @click="$router.go(-1)"><i class="fa fa-arrow-left"></i> Back</b-button>
                </div>
              </div>

              <!-- The rest of your quotation content is unchanged -->
              <div class="quotation-title">
                 <div class="row py-5"> 
                    <div class="col-md-3" align="center">
                      <img v-if="logoSource" :src="logoSource" height="80" crossorigin="anonymous" />
                    </div>   
                    <div class="col-md-9 text-center">                    
                      <span class="font-size-24 text-uppercase text-info"><strong>{{Quotation ? Quotation.business2.name : ""}}</strong></span><br/>
                      <span class="font-size-18"><strong class="text-danger"></strong> <b>{{Quotation ? Quotation.branch.address : ""}}</b></span><br/>
                      <span class="font-size-18"><strong class="text-danger">Tel: </strong> <b>{{Quotation?Quotation.contacts: ""}}</b></span><br/>
                      <span class="font-size-18"><strong class="text-danger">Email: </strong> <b>{{Quotation ? Quotation.branch.email : "---"}}</b></span><br/>
                    </div>
                  </div>
              </div>
              <div style="border-top: 1px solid black;"></div>
              <div class="font-size-24 text-center py-3"><b>QUOTATION</b></div>
              <div class="row font-size-17 py-3">
                <div class="col-6">
                  <address><strong>Customer: </strong>{{ Quotation.customer }} <br /></address>
                </div>
                <div class="col-6">
                  <address><strong>Date: </strong>{{Quotation.date}} <br /><strong>Quotation Number:</strong> {{ Quotation.quotation_number }}</address>
                </div>
              </div>            
              <div style="border-top: 1px solid black;"></div>
              <div class="p-2 mt-0">
                <h3 class="font-size-16">Order summary</h3>
              </div>
              <div class="table-responsive font-size-14">
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 70px">No.</th>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th class="text-sm-end">Price</th>
                      <th class="text-sm-end">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pdt, index) in Quotation?Quotation.all:'---'" :key="index">
                      <td>{{ index+1 }}</td>
                      <td>{{pdt.product}}</td>
                      <td>{{pdt.qty}} {{pdt.unit}}</td>
                      <td class="text-sm-end">{{pdt.price.toLocaleString()}}</td>
                      <td class="text-sm-end">{{pdt.total}}</td>
                    </tr>                   
                    <tr class="gross-total-row">
                      <td colspan="5" class="border-0">
                        <h4>Total: {{ Quotation.currency+': '+Quotation.total.toLocaleString()}}</h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div style="border-top: 1px solid black;" class="mt-3"></div>
                <div class="row py-3">
                  <h5 class="text-center"><b>PAYMENTS CAN BE MADE VIA: </b></h5>
                  <table class="table font-size-15 payment-methods">
                  <thead>
                    <tr>
                      <th>Location</th>
                      <th>Account Type</th>                    
                      <th>Account Name</th>
                      <th>Account Number</th>
                      <th class="d-print-none">Show</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in PaymentOptionsData" :key="item.id" :class="{ 'payment-option-hidden-on-print': item.showstatus != 1 }">
                      <td>{{item.type_name}}</td>
                      <td>{{item.type}}</td>                    
                      <td>{{item.name}}</td>
                      <td>{{item.anumber}}</td>
                      <td class="d-print-none">
                        <div class="form-check form-switch form-switch-lg">
                          <input
                            @change="UpdateSetting(item.id,item.showstatus)"
                            class="form-check-input"
                            type="checkbox"
                            :checked="item.showstatus==1"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  </table>
                </div>
              </div>
              <div style="border-top: 1px solid black;"></div>
              <div class="font-size-14 py-4 row">
                <div class="col-md-6">
                  <span>{{Quotation ? Quotation.business2.tagline : ''}}</span>
                </div>
                <div class="col-md-6" align="right">
                  <strong>Prepared by:</strong> <span>{{Quotation ? Quotation.user : ''}}</span>
                </div>  
              </div>           
          </div>
        </div>
      </div>
    </div>
    <b-modal id="share-whatsapp-modal" hide-footer class="d-print-none" header-bg-variant="info" header-text-variant="light">
       <template #modal-title> Share Quotation Via WhatsApp</template>
       <p>The quotation PDF has been downloaded. How would you like to open WhatsApp to share it?</p>
       <div class="d-flex justify-content-center">
         <button type="button" class="btn btn-success me-2" @click="shareToWhatsApp('app')"><i class="fab fa-whatsapp me-2"></i>WhatsApp App</button>
         <button type="button" class="btn btn-secondary" @click="shareToWhatsApp('web')"><i class="fa fa-desktop me-2"></i>WhatsApp Web</button>
       </div>
    </b-modal>
  </Layout>
</template>

<style>
.table .gross-total-row td {
  text-align: right !important;
  font-weight: bold;
}

@media print {
  * {
    box-sizing: border-box;
    
  }
    .payment-option-hidden-on-print { display: none !important; }

  .left-side-menu, .navbar-custom, .footer, .page-header, .d-print-none {
    display: none !important;
  }
  body { background-color: #fff !important; }
  .main-content, .page-content, .container-fluid {
    width: 100% !important; margin: 0 !important; padding: 0 !important;
  }
  #quotation-content-wrapper {
    border: none !important; box-shadow: none !important; padding: 0 !important;
  }

  /* --- FORMAT 1: Standard A4/A3/A5 Styles --- */
  /* This view will have NO vertical borders */
  @media (min-width: 150mm) {
    @page { margin: 15mm; }
    #quotation-content { font-size: 10pt !important; }
    #quotation-content .font-size-24 { font-size: 18pt !important; }
    #quotation-content .font-size-18 { font-size: 12pt !important; }
    #quotation-content .table tr { page-break-inside: avoid; }
    #quotation-content .gross-total-row h4 { font-size: 12pt; }
  }


  /* --- FORMAT 2: Receipt Printer Styles --- */
  /* This view WILL HAVE vertical borders */
  @media (max-width: 100mm) {
    @page {
      margin: 0;
    }
    #quotation-content {
      width: 100% !important;
      padding: 0 3mm !important; 
      font-family: 'Courier New', Courier, monospace !important;
      font-size: 9pt !important;
      color: #000 !important;
      overflow-wrap: break-word;
      word-wrap: break-word; 
    }
    
    #quotation-content .row:not(.d-print-none) { display: block !important; }
    #quotation-content [class*="col-"]:not(.d-print-none) {
      width: 100% !important; padding: 0 !important; text-align: left !important;
    }
    
    #quotation-content .text-center { text-align: center !important; }
    #quotation-content .text-sm-end { text-align: right !important; }
    #quotation-content img { max-width: 100% !important; height: auto !important; margin-bottom: 5px; }
    #quotation-content .font-size-24 { font-size: 12pt !important; font-weight: bold; }
    #quotation-content .font-size-18 { font-size: 10pt !important; line-height: 1.2; }
    #quotation-content h3 { font-size: 10pt !important; font-weight: bold; }
    
    /* MODIFIED: Add border-collapse */
    #quotation-content .table {
      font-size: 8pt !important;
      table-layout: fixed;
      width: 100%;
      border-collapse: collapse; /* This is key for a clean grid */
    }
    
    /* MODIFIED: Add vertical borders to table cells */
    #quotation-content .table th, #quotation-content .table td {
      padding: 3px 2px !important;
      border-bottom: 1px dotted #000 !important;
      border-right: 1px dotted #000; /* Add right border */
      word-wrap: break-word; /* Prevents text cutoff */
    }
    /* ADDED: Rule to add the leftmost border */
    #quotation-content .table th:first-child, #quotation-content .table td:first-child {
      border-left: 1px dotted #000; /* Add left border to the first column */
    }

    /* Precise Column Width Control */
    #quotation-content .table th:nth-child(1), #quotation-content .table td:nth-child(1) { width: 10% !important; }
    #quotation-content .table th:nth-child(2), #quotation-content .table td:nth-child(2) { width: 45% !important; }
    #quotation-content .table th:nth-child(3), #quotation-content .table td:nth-child(3) { width: 15% !important; }
    #quotation-content .table th:nth-child(4), #quotation-content .table td:nth-child(4) { width: 15% !important; }
    #quotation-content .table th:nth-child(5), #quotation-content .table td:nth-child(5) { width: 15% !important; }
    

    /* Gross Total Row - Remove grid lines from this row */
    #quotation-content .table .gross-total-row td {
        text-align: right !important;
        border-top: 1px solid #000 !important;
        border-bottom: none !important;
        border-left: none !important;
        border-right: none !important;
        padding-top: 5px !important;
    }

    #quotation-content .table .gross-total-row h4 {
        display: inline;
        margin: 0;
        font-size: 10pt;
        font-weight: bold;
    }
    #quotation-content .table .gross-total-row h4:first-child {
       margin-right: 8px; 
    }

    /* Final cleanup rules */
    #quotation-content .table thead tr { border-bottom: 1px solid #000 !important; }
    #quotation-content div[style*="border-top"] {
      border-top: 1px dashed black !important;
      margin: 5px 0 !important;
    }
    #quotation-content .py-5, #quotation-content .py-3,
    #quotation-content .p-2, #quotation-content .py-4 {
      padding-top: 5px !important;
      padding-bottom: 5px !important;
    }
  }
  /* Style to hide unchecked payment options during PDF generation */
.pdf-generating .payment-option-hidden-on-print {
  display: none !important;
}
}
</style>